import { useState } from 'react';
import { SelectableRow } from '@components/SelectableRow';
import { IconDoNotDisturb } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const SelectableRowSection = () => {
  const [selectedRow, setSelectedRow] = useState<string | null>('dental');

  const rows = [
    { id: 'dental', label: 'Dental Clinic', value: 187 },
    { id: 'derma', label: 'Dermatology', value: 142 },
    { id: 'eye', label: 'Eye Clinic', value: 98 },
    { id: 'pharmacy', label: 'Pharmacy', value: 256 },
  ];

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Selectable Row"
        description="A table row component with selectable state for displaying label-value pairs. Used in data lists and tables."
        figmaNodeId="632-15795"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Interactive List</h3>
        <div className={styles.selectableRowContainer}>
          {rows.map((row) => (
            <SelectableRow
              key={row.id}
              label={row.label}
              value={row.value}
              selected={selectedRow === row.id}
              onClick={() => setSelectedRow(row.id)}
            />
          ))}
        </div>
        <p className={styles.hint}>
          Selected: <strong>{rows.find((r) => r.id === selectedRow)?.label || 'None'}</strong>
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>States</h3>
        <div className={styles.selectableRowContainer}>
          <SelectableRow label="Default State" value="100" />
          <SelectableRow label="Selected State" value="200" selected />
          <SelectableRow label="Disabled State" value="300" disabled />
        </div>
        <p className={styles.hint}>Hover over the first row to see the hover state.</p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Muted State (Not OK)</h3>
        <div className={styles.selectableRowContainer}>
          <SelectableRow
            label="Muted Row"
            subtitle="www.muted-example.com"
            value={75}
            muted
            statusIcon={<IconDoNotDisturb size={18} />}
          />
          <SelectableRow
            label="Muted + Selected"
            subtitle="www.muted-selected.com"
            value={42}
            muted
            selected
            statusIcon={<IconDoNotDisturb size={18} />}
          />
        </div>
        <p className={styles.hint}>
          Muted rows use tertiary text color but remain clickable. Used for &quot;Not OK&quot; leads with a status icon.
        </p>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Text Overflow</h3>
        <div className={styles.selectableRowContainer}>
          <SelectableRow
            label="Very Long Label That Should Be Truncated With Ellipsis When It Overflows"
            value="1,234,567"
          />
        </div>
        <p className={styles.hint}>Labels that exceed the available width are truncated with ellipsis.</p>
      </div>
    </section>
  );
};
